import apiFetch from '../apiFetch'

export default function (idTipoDiluyente) {
  return apiFetch({endPoint: `TipoDiluyente/deleteTipoDiluyente?idTipoDiluyente=` + idTipoDiluyente, method: 'GET', body: null})
}
